import api from './api'
import type { Workflow, WorkflowCreateInput, WorkflowListResponse } from '@/schemas/workflow'

export const workflowService = {
  async list(
    projectId: string,
    params?: { page?: number; page_size?: number }
  ): Promise<WorkflowListResponse> {
    const response = await api.get<WorkflowListResponse>(
      `/projects/${projectId}/workflows`,
      { params }
    )
    return response.data
  },

  async get(projectId: string, workflowId: string): Promise<Workflow> {
    const response = await api.get<Workflow>(
      `/projects/${projectId}/workflows/${workflowId}`
    )
    return response.data
  },

  async create(projectId: string, data: WorkflowCreateInput): Promise<Workflow> {
    const response = await api.post<Workflow>(
      `/projects/${projectId}/workflows`,
      data
    )
    return response.data
  },

  async update(
    projectId: string,
    workflowId: string,
    data: Record<string, unknown>
  ): Promise<Workflow> {
    const response = await api.patch<Workflow>(
      `/projects/${projectId}/workflows/${workflowId}`,
      data
    )
    return response.data
  },

  async delete(projectId: string, workflowId: string): Promise<void> {
    await api.delete(`/projects/${projectId}/workflows/${workflowId}`)
  },
}
